import { render, staticRenderFns } from "./DatetimeCalendar.vue?vue&type=template&id=527d8136&scoped=true&"
import script from "./DatetimeCalendar.vue?vue&type=script&lang=js&"
export * from "./DatetimeCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DatetimeCalendar.vue?vue&type=style&index=0&id=527d8136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d8136",
  null
  
)

export default component.exports